<template>
  <div class="container text-center" id="main">
    <div class="row">
      <div class="col-sm-12 message">
        <p>
            Please close your browser to sign out of myCSUB session
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signout',
  data () {
    return { }
  }
}
</script>

<style scoped>
  #main .row {
    margin-left: 20px;
  }

  .message {
    padding: 50px 0;
  }
</style>
